module.exports = __webpack_public_path__ + "static/media/51SFK0A66YL._AC_UX569_.fe54dca9.jpg";